import { MuseumBuyerDef } from '../types';

export const MUSEUM_BUYERS: MuseumBuyerDef[] = [
  {
    id: 'natural_history',
    name: 'Natural History Museum',
    preferredTypes: ['bone', 'tool'],
    preferredEras: ['prehistoric', 'neolithic', 'proto_human'],
    baseMultiplier: 1.2,
    relationship: 0,
  },
  {
    id: 'art_museum',
    name: 'Metropolitan Art Gallery',
    preferredTypes: ['art', 'jewelry', 'pottery'],
    preferredEras: ['classical', 'medieval', 'renaissance'],
    baseMultiplier: 1.3,
    relationship: 0,
  },
  {
    id: 'archaeology_inst',
    name: 'Institute of Archaeology',
    preferredTypes: ['tool', 'document', 'structure'],
    preferredEras: ['neolithic', 'bronze_age', 'iron_age', 'classical', 'medieval', 'renaissance', 'ancient', 'prehistoric', 'proto_human'],
    baseMultiplier: 1.0,
    relationship: 20,
  },
  {
    id: 'private_collector',
    name: 'Private Collector',
    preferredTypes: ['weapon', 'coin', 'jewelry'],
    preferredEras: ['neolithic', 'bronze_age', 'iron_age', 'classical', 'medieval', 'renaissance', 'ancient', 'prehistoric', 'proto_human'],
    baseMultiplier: 1.5,
    relationship: 0,
  },
  {
    id: 'university',
    name: 'University Research Dept',
    preferredTypes: ['document', 'bone', 'religious'],
    preferredEras: ['neolithic', 'bronze_age', 'iron_age', 'classical', 'medieval', 'renaissance', 'ancient', 'prehistoric', 'proto_human'],
    baseMultiplier: 0.8,
    relationship: 0,
  },
  {
    id: 'national_museum',
    name: 'National Museum',
    preferredTypes: ['coin', 'religious', 'art', 'pottery', 'weapon', 'jewelry', 'tool', 'bone', 'document', 'structure'],
    preferredEras: ['neolithic', 'bronze_age', 'iron_age', 'classical', 'medieval', 'renaissance', 'ancient', 'prehistoric', 'proto_human'],
    baseMultiplier: 1.1,
    relationship: 0,
  },
];

export function getMuseumBuyer(id: string): MuseumBuyerDef | undefined {
  return MUSEUM_BUYERS.find((buyer) => buyer.id === id);
}
